import 'bootstrap'; // Импорт скриптов Bootstrap, включая jQuery
import jQuery from 'jquery';
import { Tooltip } from 'react-bootstrap';

// Элементы select
var $selectSize = jQuery("#modalSize");
var $selectType = jQuery("#modalType");
var $selectFields = jQuery("#modalFields");
var $selectLaminat = jQuery("#modalLaminat");
var $selectProcessingMethod = jQuery("#processing_method");

// Выбор количества
var $selectCount = jQuery("#defaultCount");


// label выбора файла
var $uploadFile = jQuery('#uploadFile')

/**
 * Функция устанавливает значения различных полей в модальном окне на основе свойств объекта
 * изображения и запускает событие щелчка по кнопке загрузки файла.
 * @param image - Параметр «изображение» — это объект, который содержит следующие свойства:
 */
function setToolPanelEditorModal(image) {
	let paper_size = image["paper_size"]
	let paper_type = image["paper_type"]
	let cadr = image["cadr"]
	let laminat = image["laminat"]

	if (cadr == 2) {
		cadr = 0
	}

	$selectSize.val(paper_size)
	$selectType.val(paper_type)
	$selectFields.val(cadr)
	$selectLaminat.val(laminat)

	checkUploadField()
	$uploadFile.click();
}

function init_select() {
	$selectSize.html("")
	$selectType.html("")
	$selectFields.html("")
	$selectLaminat.html("")
	$selectProcessingMethod.html("")

	$selectSize.append(jQuery('<option>', { value: "", text: "Выберите размер" }).prop('selected', true));

	var sizesArray = [];
	for (var key in window.sizes) {
		var size = window.sizes[key];
		size.key = key;  // Сохраняем ключ, если он понадобится позже
		sizesArray.push(size);
	}

	// Сортируем массив по полю order
	sizesArray.sort(function (a, b) {
		return a.order - b.order;
	});

	// Добавляем элементы в $selectSize в отсортированном порядке
	jQuery.each(sizesArray, function (index, size) {
		$selectSize.append(jQuery('<option>', { value: size.id, text: size.title }));
	});

	$selectType.append(jQuery('<option>', { value: "", text: "Выберите материал" }).prop('selected', true));

	for (var key in window.types) {
		$selectType.append(jQuery('<option>', { value: window.types[key]["id"], text: window.types[key]["title"] }));
	};

	$selectType.find("option[value='0']").prop('selected', true)



	$selectFields.append(jQuery('<option>', { value: "", text: "Выберите поля" }));
	$selectFields.append(jQuery('<option>', { value: "1", text: "С полями" }));
	$selectFields.append(jQuery('<option>', { value: "0", text: "Без полей" }).prop('selected', true));


	$selectLaminat.append(jQuery('<option>', { value: "", text: "Выберите ламинацию" }));
	$selectLaminat.append(jQuery('<option>', { value: "1", text: "С ламинацией" }));
	$selectLaminat.append(jQuery('<option>', { value: "0", text: "Без ламинации" }).prop('selected', true));


	$selectProcessingMethod.append(jQuery('<option>', { value: "", text: "Выберите способ обработки" }));
	$selectProcessingMethod.append(jQuery('<option>', { value: "1", text: "Кадрировать на сайте" }).prop('selected', true));
	$selectProcessingMethod.append(jQuery('<option>', { value: "0", text: "Отдать на кадрирование (+1 руб. за фото)" }));

}

jQuery("body").on("click", ".add_img_card", function () {
	let imageWrapper = jQuery(this).prev();
	let id = parseInt(jQuery(imageWrapper).attr('id').replace('wrap_', ''))
	setToolPanelEditorModal(window.images[id])
});





/**
 * Функция `window.preloadImages` используется для асинхронной загрузки изображений с использованием AJAX и
 * заполнения объекта `window.images` данными ответа.
 */
window.preloadImages = function () { // loadingFader('show');
	jQuery.ajax({
		url: '/ajax/editor/preload',
		type: 'POST',
		cache: false,
		dataType: 'json',
		processData: false,
		contentType: false,
		success: function (response, status, jqXHR) {
			jQuery.each(response, function (key, val) {
				window.images[key] = val;
			});
			window.reset_element(true)
			loadingFader('hide');
			calcEditorPrice()
			genTabs()
			renderTabs()
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			loadingFader('hide');
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
}

window.preloadImages_no_reset = function () {
	jQuery.ajax({
		url: '/ajax/editor/preload',
		type: 'POST',
		cache: false,
		dataType: 'json',
		processData: false,
		contentType: false,
		success: function (response, status, jqXHR) {
			jQuery.each(response, function (key, val) {
				window.images[key] = val;
			});
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) { }
	});
}

window.selectedImages = [];

/**
 * Функция `add_list_imageSelect` добавляет идентификатор изображения в массив `selectedImages`, если
 * его еще нет.
 * @param id - Параметр id — это идентификатор изображения, которое выбирается.
 */
function add_list_imageSelect(id_int) {
	let id = Number(id_int)
	let index = window.selectedImages.indexOf(id);
	if (index == -1) {
		window.selectedImages.push(id);
		reset_text_count_selected()
	}
}


/**
 * Функция обновляет количество выбранных изображений и отображает его в элементе HTML с
 * идентификатором «count_selected».
 */
function reset_text_count_selected() {
	let count = window.selectedImages.length
	if (count > 0) {
		jQuery("#count_selected").html(`(${count})`)
	}
	else {
		jQuery("#count_selected").html("")
	}
}

jQuery("body").on('click', '.imageSelect', function () {
	let $el = jQuery(this)
	let id = parseInt(jQuery($el).val().replace('wrap_', ''))
	let checked = $el.is(':checked')
	if (checked) {
		add_list_imageSelect(id)
	} else {
		let index = window.selectedImages.indexOf(id);
		if (index !== -1) {
			window.selectedImages.splice(index, 1);
			reset_text_count_selected()
		}
	}
});

if ('touchend' in window) {
	jQuery("body").on('touchend', '.imageWrapper:not(.preload)', function (event) {
		let $target = jQuery(event.target)
		let $imageWrapper = jQuery(this).is(".imageWrapper") ? jQuery(this) : jQuery(this).parents(".imageWrapper")
		let $el = ""

		if ($target.is('.imageWrapper') || $target.is('.imageCanvasContainer')) {
			$el = $imageWrapper.find(".imageSelect");
		}

		if ($el.length > 0) {
			let $el = jQuery(this).find(".imageSelect");
			let isChecked = $el.prop('checked');
			isChecked = !isChecked;
			$el.prop('checked', isChecked);
			let id = parseInt(jQuery($el).val().replace('wrap_', ''));
			if (isChecked) {
				add_list_imageSelect(id);
			} else {
				let index = window.selectedImages.indexOf(id);
				if (index !== -1) {
					window.selectedImages.splice(index, 1);
					reset_text_count_selected();
				}
			}
		}
	});
}
else {
	jQuery("body").on('mousedown', '.imageWrapper:not(.preload)', function (event) {
		let $target = jQuery(event.target)
		let $imageWrapper = jQuery(this).is(".imageWrapper") ? jQuery(this) : jQuery(this).parents(".imageWrapper")
		// Проверяем, является ли цель клика .imageWrapper
		if ($target.is('.imageWrapper') || $target.is('.imageCanvasContainer')) {
			$imageWrapper.data('isClick', true);
		}
		else {
			$imageWrapper.data('isClick', false);

		}
	});

	jQuery("body").on('mouseup', '.imageWrapper:not(.preload)', function (event) {
		// Проверяем, было ли движение мыши или касание
		let $target = jQuery(event.target)
		let $imageWrapper = jQuery(this).is(".imageWrapper") ? jQuery(this) : jQuery(this).parents(".imageWrapper")
		let isClick = $imageWrapper.data('isClick');
		let $el = ""

		if ($target.is('.imageWrapper') || $target.is('.imageCanvasContainer')) {
			$el = $imageWrapper.find(".imageSelect");
		}

		if (isClick == false) {
			return false;
		}

		if ($el.length > 0) {
			let $el = $imageWrapper.find(".imageSelect");
			let isChecked = $el.prop('checked');
			isChecked = !isChecked;
			$el.prop('checked', isChecked);
			let id = parseInt(jQuery($el).val().replace('wrap_', ''));
			if (isChecked) {
				add_list_imageSelect(id);
			} else {
				let index = window.selectedImages.indexOf(id);
				if (index !== -1) {
					window.selectedImages.splice(index, 1);
					reset_text_count_selected();
				}
			}
		}
		else {
			$imageWrapper.data('isClick', false);
		}
	});
}

setInterval(function () {
	reset_imageCanvas_position();
	// reset_position_relative();
}, 10);

setInterval(function () {
	reset_draggable();
	install_checkboxes();
	calcEditorPrice();
}, 500);

function install_checkboxes() {
	window.selectedImages.forEach(item => {
		jQuery(`.imageSelect[value="wrap_${item}"]`).prop("checked", true)
	});
}

window.select_tab = 0;


jQuery("body").on("click", ".deselect_the_selection button", function () {
	jQuery(".imageSelect, .imagesSizeContainer > * > .form-check-input").prop("checked", false);
	window.selectedImages = [];
	reset_text_count_selected()
})

jQuery("body").on("click", ".select_all button", function () {
	select_the_entire_category()
})

function select_the_entire_category() {

	let select_list = Object.keys(window.images).filter(key => window.images[key].paper_size == window.select_tab && !window.images[key]?.preload)

	select_list = select_list.map((str) => {
		return parseInt(str);
	});


	window.selectedImages = select_list;
	install_checkboxes()
	reset_text_count_selected()
}

function preloadData() {
	jQuery.ajax({
		url: '/ajax/editor/loadData',
		type: 'POST',
		cache: false,
		dataType: 'json',
		processData: false,
		contentType: false,
		success: function (response, status, jqXHR) {
			jQuery.each(response.sizes, function (key, val) {
				window.sizes[key] = val;
			});
			jQuery.each(response.types, function (key, val) {
				window.types[key] = val;
			});

			if (window.select_tab == undefined) {
				window.select_tab = 16
			}

			window.prices = response.prices;
			init_select()
			window.preloadImages();
			calcTablePrice();
			calcEditorPrice();
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
}

var uploadTimer;

window.validation_data_retention = function (elm_id, data, value) {
	// Проверка на ламинацию
	if (data == "laminat") {
		let elm = window.images[elm_id]
		let lam = (value == '1') ? 'lam' : 'nolam';
		let price = parseFloat(window.prices[elm.paper_size][elm.paper_type][lam].price);
		if (price <= 0) {
			// console.log(`[${elm_id}] ${data} (Не валидно) ${value}`)
			return false;
		}
	}
	return true
}


/**
 * Проверка на то что доступна ламинация
 */
function validation_save_data_retention(paper_size, paper_type, laminat) {
	let obj = window.prices[paper_size][paper_type]
	if (laminat == 1) {
		obj = obj["lam"]
	} else {
		obj = obj["nolam"]
	}
	let price = parseFloat(obj["price"]);
	if (price <= 0) {
		return false;
	}
	return true
}

window.saveDataList = function (elm, params) {
	let valid_all = true

	for (let [key, value] of Object.entries(params)) {
		if (!window.validation_data_retention(elm, key, value)) {
			valid_all = false
		}
	};
	if (!valid_all) {
		return false
	}
	for (let [key, value] of Object.entries(params)) {
		window.saveData(elm, key, value, false)
	};
	return true
}

window.saveData = function (elm, data, value, valid = true) {

	if (valid) {
		if (!window.validation_data_retention(elm, data, value)) {
			return false;
		}
	}

	// console.log(`[${elm}] ${data} = ${value}`)
	window.images[elm][data] = value;

	// // console.log(elm, data, value)
	clearTimeout(uploadTimer);
	uploadTimer = setTimeout(function () {
		var jsonData = JSON.stringify(window.images);
		jQuery.ajax({
			url: '/ajax/editor/saveData',
			type: 'POST',
			contentType: 'application/json',
			data: jsonData,
			success: function (response, status, jqXHR) {
				//       window.reset_element(true)
			},
			// функция ошибки ответа сервера
			error: function (jqXHR, status, errorThrown) {
				//       window.reset_element(true)
			}
		});
	}, 1000);

	return true;
}

/**
 * Функция изменяет размер элемента либо масштабируя его с помощью преобразования CSS, либо напрямую
 * изменяя его ширину и высоту.
 * @param div - Параметр `div` — это объект jQuery, представляющий элемент, размер которого вы хотите
 * изменить.
 * @param value - Параметр value представляет коэффициент масштабирования, на который должен быть
 * изменен размер элемента. Это может быть любое положительное число больше 0.
 * @param [transform=false] - Параметр «преобразование» — это логическое значение, которое определяет,
 * должно ли изменение размера выполняться с помощью преобразования CSS или путем непосредственного
 * изменения свойств ширины и высоты элемента.
 */
function resizeElem(div, value, transform = false) {
	if (transform) {
		div.css({
			"transform": `scale(${value})`,
			"transform-origin": "0 0"
		})

	} else {
		var currentWidth = div.width();
		var currentHeight = div.height();
		div.width(currentWidth * value);
		div.height(currentHeight * value);
	}
}


/**
 * Функция `getImagePathForBrowser` принимает путь к файлу в качестве входных данных и возвращает тот
 * же путь с измененным на ".jpg" расширением файла.
 * @param path - Параметр `path` представляет собой строку, представляющую путь к файлу изображения.
 * @returns обновленный путь к изображению с измененным расширением файла на «.jpg».
 */
function getImagePathForBrowser(path) {
	let extIndex = path.lastIndexOf('.');
	if (extIndex >= 0) {
		path = path.substring(0, extIndex) + '.jpg';
	}

	return path;
}

/* Приведенный выше код представляет собой фрагмент кода JavaScript, который обрабатывает событие
щелчка на элементе с классом «fa-magnifying-glass» внутри элемента с идентификатором «root». */
jQuery("#root").on("click", ".fa-magnifying-glass", function () {
	let data = {
		'id': jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', ''),
	};
	loadingFader('show');
	jQuery.ajax({
		url: '/ajax/editor/loadPreview',
		type: 'POST',
		data: data,
		success: function (response, status, jqXHR) {
			jQuery.ajax({
				url: '/ajax/editor/loadPreview',
				type: 'POST',
				data: data,
				success: function (response, status, jqXHR) {
					jQuery('#previewModalBody').html('<img src="' + response + '" class="previewImage">');
					window.openBootstrapModal(jQuery('#previewModal'))

					loadingFader('hide');
				},
				// функция ошибки ответа сервера
				error: function (jqXHR, status, errorThrown) {
					loadingFader('hide');
					// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
				}
			});
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			loadingFader('hide');
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
	return false;
})

/**
 * Функция обновляет размер элемента карты на веб-странице.
 */
window.update_resizeElem = function () {
	// Умножаем на 10
	window.card_size *= 10;

	// Округляем до целого
	window.card_size = Math.round(window.card_size);

	// Делим обратно на 10
	window.card_size /= 10;

	if (window.card_size >= 0.8) {
		document.documentElement.style.setProperty('--card-scale', window.card_size);
	}
	else {
		window.card_size = 0.8
	}
}

var position_list_css_padding_top = 0
var position_list_css_padding_bottom = 0
var position_list_scrollTop = 0

/**
 * Функция «load_position_list» используется для загрузки списка позиций и при необходимости прокрутки
 * до определенной позиции.
 */
window.load_position_list = function () {
	if (position_list_scrollTop != 0) {
		jQuery(".virtuoso-grid-list").css("padding-top", position_list_css_padding_top)
		jQuery(".virtuoso-grid-list").css("padding-bottom", position_list_css_padding_bottom)
		jQuery(`[data-test-id="virtuoso-scroller"]`).scrollTop(position_list_scrollTop);
		position_list_scrollTop = 0
	}
}

/**
 * Функция сохраняет положение списка, сохраняя значения свойств CSS padding top и bottom, а также
 * позицию прокрутки.
 */
window.save_position_list = function () {
	position_list_css_padding_top = jQuery(".virtuoso-grid-list").css("padding-top")
	position_list_css_padding_bottom = jQuery(".virtuoso-grid-list").css("padding-bottom")
	position_list_scrollTop = jQuery(`[data-test-id="virtuoso-scroller"]`).scrollTop();
	// console.log("Положение списка сохранёно", position_list_css_padding_top, position_list_css_padding_bottom, position_list_scrollTop)
}



/**
 * Функция genTabs() создает вкладки на основе размеров бумаги и названий изображений.
 */
function genTabs() {
	checkUploadField()
	window.tabs = {}
	for (let key in window.images) {
		let id = window.images[key]["paper_size"]
		let text = window.window.sizes[id]["title"]
		if (id >= 0 && text.length > 0)
			window.tabs[id] = text
	}
}

function renderSelectTabs(tab) {
	jQuery(`#card_img_grupe_tabs .item_tab[data-id='${window.select_tab}']`).addClass("active")
}

function renderTabs() {
	// Обновить табы
	jQuery("#card_img_grupe_tabs .item_tab").remove();


	for (let key_tab in window.tabs) {
		let tab = jQuery(`<a class='item_tab' data-id='${key_tab}'>${window.tabs[key_tab]}</a>`)

		tab.on("click", function () {
			window.select_tab = key_tab
			window.save_position_list()
			window.reset_element(true)
			jQuery("#card_img_grupe_tabs .item_tab").removeClass("active")


			position_list_css_padding_top = 0
			position_list_css_padding_bottom = 0
			position_list_scrollTop = 1
			fix_padding_virtuoso_grid()
			window.load_position_list()

			jQuery(this).addClass("active")
			$selectSize.val(key_tab)
			checkUploadField()
		})
		jQuery("#card_img_grupe_tabs").append(tab)
	};

	// if (window.select_tab === 0) {
	// 	window.select_tab = Object.keys(window.tabs)[0];
	// 	$selectSize.val(window.select_tab)
	// 	jQuery(`#card_img_grupe_tabs .item_tab[data-id='${window.select_tab}']`).addClass("active")
	// }

	renderSelectTabs()
}

var first_elem = null;
var last_elem = null;
var shifted = false;

jQuery(document).on('keyup keydown', function (e) {
	shifted = e.shiftKey
});

jQuery("body").on("change", ".imageSelect", function (e) {
	selection_processing(jQuery(this))
});

jQuery("body").on('click', '.imageWrapper', function (event) {
	// Проверяем, является ли цель клика .imageWrapper
	if (jQuery(event.target).is('.imageWrapper')) {
		let $el = jQuery(this).find(".imageSelect")
		selection_processing($el)
	}
})


function selection_processing($el) {
	if (shifted) {
		// console.log("Shift зажат")

		last_elem = jQuery($el)
		let end = jQuery(last_elem).attr("value")
		end = Number(end.replace("wrap_", ""))

		let start = jQuery(first_elem).attr("value")
		start = Number(start.replace("wrap_", ""))

		if (start > end) {
			let buff = start
			start = end
			end = buff
		}

		// console.log("Выбран диапазон", start, end)

		let category_first = window.images[start]["paper_size"]

		for (let i = start; i <= end; i++) {
			let val = window.images[i]
			if (val) {
				if (val["paper_size"] == category_first) {
					let checkbox_select = `#wrap_${i} input[type='checkbox']`
					let checkbox = jQuery(checkbox_select);
					if (checkbox.length > 0) {
						checkbox.prop('checked', true);
						add_list_imageSelect(i)
					}
				}
			}
		}
	}
	else {
		// console.log("Без шифта")
	}
	first_elem = jQuery($el)
}

var number_of_selected_cards = 0

jQuery('#imagesContainer').find('.imageSelect').change(function () {
	let number_of_selected_cards = jQuery('#imagesContainer').find('.imageSelect:checked').length

	if (number_of_selected_cards > 0) {
		$selectProcessingMethod.attr("disabled", "false")
	}
	else {
		$selectProcessingMethod.attr("disabled", "true")
	}
})

/**
 * Функция "getSelected" возвращает в окно выбранные изображения.
 * @returns значение переменной "window.selectedImages".
 */
function getSelected() {
	return window.selectedImages;
}

/**
 * Функция «nextType» возвращает следующий ключ в объекте «types» после данного ключа «id».
 * @param id - Параметр `id` является текущим идентификатором типа.
 * @returns следующий тип в объекте «типы» после данного «идентификатора». Если следующего типа нет, он
 * вернет первый тип в объекте.
 */
function nextType(id) {
	let next = false;
	for (let i in window.types) {
		if (window.types.hasOwnProperty(i)) {
			if (next)
				return i;
			else if (i == id)
				next = true;
		}
	}
	for (let i in window.types)
		if (window.types.hasOwnProperty(i))
			return i;
}

var loadingFader_interval = null

var all_count_filesToUpload = 0

/**
 * Функция обновляет индикатор выполнения и процентное отображение элемента фейдера загрузки в
 * зависимости от количества загружаемых файлов.
 */
function loadingFader_update_element() {
	if (all_count_filesToUpload < filesToUpload.length - 2) {
		all_count_filesToUpload = filesToUpload.length
	}

	if (all_count_filesToUpload == 0) {
		all_count_filesToUpload = filesToUpload.length + 1
	}
	let d = 100 - (filesToUpload.length / all_count_filesToUpload * 100)

	let procent = Math.round(d)
	procent = Math.abs(procent)

	jQuery("#loadingFaderProgress .progress-bar").css("width", `${d}%`)
	jQuery("#loadingFaderProgress .procent").html(`${procent}%`)
	jQuery("#loadingFaderProgress .count").html(`${all_count_filesToUpload}шт`)
}

function fix_padding_virtuoso_grid() {
	let padding_top = jQuery(".virtuoso-grid-list").css("padding-top")
	let padding_bottom = jQuery(".virtuoso-grid-list").css("padding-bottom")

	if (padding_top) {
		padding_top = parseFloat(padding_top)
		padding_bottom = parseFloat(padding_bottom)

		jQuery(".virtuoso-grid-list").css("padding-top", 0)
		jQuery(".virtuoso-grid-list").css("padding-bottom", padding_top + padding_bottom + "px")
	}
}

function loadingFader(action, full = false) {

	if (full) {
		// На весь экран

		if (action == 'show') {
			let $loadingFader_full = jQuery("<div id='over_loadingFader_full'><div id='preloader_loadingFader_full'></div></div>")
			jQuery("#card_img_grupe").append($loadingFader_full)
		}
		else if (action == 'hide') {
			jQuery("#over_loadingFader_full").remove()
		}
	}
	else {
		if (action == 'show') {

			jQuery("#loadingFaderProgress").remove()

			let uploadBar = jQuery(`
			<div id="loadingFaderProgress">
				<div class="progress"
					style="width: 70px">
					<div class="progress-bar"
						role="progressbar"
						style="width: 0%; background-color: #ff284c; border: none;"
						aria-valuenow="50"
						aria-valuemin="0"
						aria-valuemax="100"></div>
				</div>
				<span class="procent">0%</span>
				<span class="count_label">
					<span style="width: 53px;display: block;line-height: 15px;color: black;font-size: 12px;">
						ОБЩЕЕ КОЛ-ВО
					</span>
					<span class="count" style="line-height: 18px;">0</span>
				</span>
			</div>
			`);

			loadingFader_interval = setInterval(loadingFader_update_element, 100);

			jQuery('#top_panel_param').append(uploadBar);
		} else if (action == 'hide') {
			if (loadingFader_interval) {
				clearInterval(loadingFader_interval)
				all_count_filesToUpload = 0
				jQuery('#loadingFaderProgress').remove();
			}
			jQuery('#loadingFaderProgress').remove();
		}
	}
}

function checkUploadField() {



	if ($selectSize.val() && $selectType.val() && $selectFields.val() && $selectLaminat.val()) {
		if (!validation_save_data_retention($selectSize.val(), $selectType.val(), $selectLaminat.val())) {
			// $uploadFile.prop('disabled', true);
			jQuery('#noLoadImages').show().html('Вы не можете использовать этот тип ламинации для этого размера');
		}
		else {
			// $uploadFile.prop('disabled', false);
			jQuery('#noLoadImages').hide();
		}
	} else {
		jQuery('#noLoadImages').show().html('Сначала надо выбрать размер, материал, поля, ламинацию и способ обработки');
	}
}
jQuery(document).ready(function () {
	jQuery("#open_grupe_updateSelected").click(function () {
		jQuery("#grupe_updateSelected").toggleClass("open")
	})
});


/**
 * Функция разбивает заданный список на группы заданного размера.
 * @param list - Параметр `list` представляет собой массив, содержащий элементы, которые нужно
 * разделить на группы.
 * @param groupSize - Параметр `groupSize` - это желаемый размер каждой группы. Он определяет, сколько
 * элементов должно быть в каждой группе при разбиении списка.
 * @returns Функция splitIntoGroups возвращает массив массивов, где каждый внутренний массив
 * представляет собой группу элементов из исходного списка.
 */
function splitIntoGroups(list, groupSize) {
	const groups = [];
	for (let i = 0; i < list.length; i += groupSize) {
		// разбиваем на группы по заданному размеру
		const group = Array.from(list).slice(i, i + groupSize);
		groups.push(group);
	}
	return groups;
}


/**
 * Функция «reset_position_relative» сбрасывает позицию элемента изображения, чтобы обеспечить
 * правильное отображение.
 */
function reset_position_relative() {
	jQuery(`[data-cadr="0"] .imageCanvas`).not(".position_static_to_relative_2").map(function () {
		let img = jQuery(this).find(`img`)
		let img_x = jQuery(img).offset().left + jQuery(img).width();
		let imageCanvas_x = jQuery(this).offset().left + jQuery(this).width();

		if (img_x < imageCanvas_x) {
			// let width = jQuery(img).css("width")
			jQuery(img).css("position", "static")
			jQuery(this).addClass("position_static_to_relative_1")
		}
	})

	jQuery(`.position_static_to_relative_1`).addClass("position_static_to_relative_2").removeClass("position_static_to_relative_1").find("img").css("position", "relative")
}


/**
 * Функция `split_dict_chank` принимает словарь и размер группы в качестве входных данных и разбивает
 * словарь на группы указанного размера.
 * @param dict - Параметр `dict` — это объект (словарь), который вы хотите разбить на более мелкие
 * группы.
 * @param groupSize - Параметр `groupSize` указывает количество элементов, которые должны быть включены
 * в каждую группу при разбиении словаря.
 * @returns Функция split_dict_chank возвращает объект, содержащий группы пар ключ-значение из входного
 * словаря. Каждая группа имеет ключ, представляющий номер группы (начиная с 1), а значение
 * представляет собой объект, содержащий пары ключ-значение из исходного словаря.
 */
function split_dict_chank(dict, groupSize) {
	const keys = Object.keys(dict);
	const groups = {};

	for (let i = 0; i < keys.length; i += groupSize) {
		// разбиваем на группы по заданному размеру
		const group = keys.slice(i, i + groupSize);
		const entries = group.map(key => [key, dict[key]]);
		groups[i / groupSize + 1] = Object.fromEntries(entries);
	}
	return groups;
}


function remove_waiting_card(id) {
	jQuery(`.waiting_card[id='wc_${id}']`).remove()
}

window.preload_list_card = {}


var restore_positions_after_loading = false;
var restore_positions_after_loading_interval = undefined;

var maxUploaders = 5;
var countUploaders = 0;
var filesToUpload = [];
var filesOverall = 0;

setInterval(() => {
	click_preload();
}, 50);


function click_preload() {
	jQuery('.imageWrapper.preload').first().click();
}

// Если пользовать первый раз загрузил фотографии
var first_shipment = true

async function uploadFiles() {

	if (first_shipment) {
		first_shipment = false
		window.openBootstrapModal(jQuery('#the_editor_cuts_the_photo'))
	}


	while (filesToUpload.length > 0 && countUploaders < maxUploaders) {

		const data_dict = filesToUpload.shift();

		const data = new FormData();
		data.append("size", data_dict["size"]);
		data.append("type", data_dict["type"]);
		data.append("fields", data_dict["fields"]);
		data.append("laminat", data_dict["laminat"]);
		data.append("count", data_dict["count"]);
		data.append("file", data_dict["file"]);

		countUploaders++;

		let response = await fetch("/ajax/editor/upload", {
			method: "POST",
			body: data,
		}).then(response => {
			if (response.ok) {
				return response.json();
			} else {
				throw new Error("Ошибка ответа сервера");
			}
		})
			// eslint-disable-next-line no-loop-func
			.then(responseJson => {
				try {
					// Проверяем, что responseJson является объектом
					if (typeof responseJson !== "object" || responseJson === null) {
						console.error("Некорректный формат ответа сервера");
						return;
					}

					const keys = Object.keys(responseJson);
					if (keys.length === 0) {
						console.warn("Пустой ответ от сервера");
						return;
					}

					const imgObj = responseJson[keys[0]];

					if (!imgObj || typeof imgObj !== "object" || imgObj === null || !("id" in imgObj)) {
						console.warn("Некорректные данные изображения в ответе сервера");
						return;
					}

					if (imgObj.id) {
						let preload_card_id = data_dict["preload_card_id"];
						if (preload_card_id) {
							if ("image_id" in window.preload_list_card[preload_card_id]) {
								window.preload_list_card[data_dict["preload_card_id"]]["image_id"] = imgObj.id;
								window.images[imgObj.id] = imgObj;
							}
						} else {
							window.images[imgObj.id] = imgObj;
						}
					}
					countUploaders--;
				} catch (error) {
					countUploaders--;
					console.error("Ошибка при обработке ответа:", error.message);
				}
			})

		// window.preloadImages_no_reset();

		if (filesToUpload.length > 0) {
			setTimeout(uploadFiles, 500);
		} else {
			loadingFader('hide');
			checkUploadField();
			for (let el in window.preload_list_card) {
				delete window.images[el];
			}
			window.preload_list_card = [];
			window.save_position_list();
			jQuery(".imageWrapper.preload").click();
			jQuery(".imageWrapper.preload").remove();
			restore_positions_after_loading = true;
			restore_positions_after_loading_interval = setInterval(() => {
				if (!restore_positions_after_loading && window.reset_status == 0) {
					let height = jQuery(`.virtuoso-grid-list`).height() + parseFloat(jQuery(`.virtuoso-grid-list`).css("padding-bottom").replace(" px"))
					if (height >= position_list_scrollTop - 5) {
						window.load_position_list()
						renderTabs();

						restore_positions_after_loading = true;
						clearInterval(restore_positions_after_loading_interval)
					}

				}
			}, 200);
			setTimeout(() => {
				all_count_filesToUpload = 0;
				window.preloadImages();
				genTabs();
				calcEditorPrice();
				setTimeout(() => {
					restore_positions_after_loading = false;
				}, 600);
			}, 500);
		}
	}
}


$uploadFile.change(function () {

	loadingFader('show');
	let files_chunk = splitIntoGroups(this.files, 1)

	let start_index_preload = Math.floor(Math.random() * 100000000)

	jQuery.each(files_chunk, function (chank_key, chunk_file) {
		let item_formdata = {};
		let files_count = 0
		jQuery.each(chunk_file, function (key_file, file) {
			item_formdata["file"] = file;
			files_count += 1
		})

		let size_id = $selectSize.val()

		item_formdata['size'] = size_id;
		item_formdata['type'] = $selectType.val();

		if ($selectProcessingMethod.val() == "0") {
			item_formdata['fields'] = "2";
		}
		else {
			item_formdata['fields'] = $selectFields.val();
		}

		item_formdata['laminat'] = $selectLaminat.val()
		item_formdata['files_count'] = files_count
		item_formdata['count'] = jQuery('#defaultCount').val()


		let preload_card_id = start_index_preload + chank_key

		item_formdata['preload_card_id'] = preload_card_id;

		window.preload_list_card[preload_card_id] = {
			'preload_id': preload_card_id, // ID прелойдера карточки на подобие p_4975394
			'image_id': null // Приходит с сервера нормальный id
		}

		window.images[preload_card_id] = {
			preload: true,
			paper_size: size_id
		}


		filesToUpload.push(item_formdata);
	});
	window.reset_element(true)
	filesOverall = filesToUpload.length;
	uploadFiles();
	jQuery(this).val('');

	return false;
});


function calcEditorPrice() {
	var total = 0;
	var balls = 0;
	var count = 0;
	var the_amount_of_paid_framing = 0;
	jQuery.each(window.images, function (key, val) {
		if (val?.paper_size !== undefined && val?.paper_type !== undefined) {
			let price = window.prices[val.paper_size][val.paper_type]
			if (val.laminat == 1) {
				price = price["lam"]
			} else {
				price = price["nolam"]
			}
			total += parseFloat(price["price"]) * val.count;
			balls += parseFloat(price["balls"]) * val.count;
			count += parseInt(val.count);
			the_amount_of_paid_framing += val.cadr == 2 ? 1 : 0 //Если платное кодирование
		}
	});

	total = Math.round(total * 100) / 100
	balls = Math.round(balls * 100) / 100

	if (the_amount_of_paid_framing > 0) {
		jQuery('#editorOverallPrice').html(total + `(+${the_amount_of_paid_framing})`);
	}
	else {
		jQuery('#editorOverallPrice').html(total);
	}

	jQuery('#editorOverallBalls').html(balls);
	jQuery('#editorOverallCount').html(count);
}

/**
 * Функция `reset_draggable()` включает функцию перетаскивания изображений внутри элемента холста с
 * возможностью сохранения и обновления положения изображения.
 */
function reset_draggable() {
	jQuery(".imageCanvas").each(function () {
		window.init_draggable(this)
	});
}


function calcTablePrice() {
	var price = 0;
	var count = 0;
	var balls = 0;
	jQuery('#price_table_main .tablePrices').each(function (key, val) {
		let size = jQuery(val).data('size');
		let type = jQuery(val).find('.tablePricesType').val();

		let laminat;
		if (jQuery(val).find('.tablePricesLaminat.active').length > 0 && jQuery(val).find('.tablePricesLaminat.active').is(':checked')) {
			laminat = 'lam';
		} else {
			laminat = 'nolam';
		}


		let itemCount = parseInt(jQuery(val).find('.tablePricesCount').val());

		if (window.prices[size][type]["lam"].price == '0.00') {
			jQuery(val).find(".tablePricesLaminat").removeClass("active").hide()
		}
		else {
			jQuery(val).find(".tablePricesLaminat").addClass("active").show()
		}

		let sCost = parseFloat(window.prices[size][type][laminat].price) * itemCount;


		jQuery(val).find('.tablePricesCost').html(sCost);
		balls += parseFloat(window.prices[size][type][laminat].balls) * itemCount;

		price += sCost;
		count += itemCount;
	});

	price = Math.round(price * 100) / 100
	balls = Math.round(balls * 100) / 100


	jQuery('#mainPriceShow').html(price);
	jQuery('#mainCountShow').html(count);
	jQuery("#mainBallsShow").html(balls)
}

jQuery('document').ready(function () {
	preloadData();

	jQuery('#mainPageUpload').click(function () {
		var isValid = true;

		if (jQuery("#mainPageFio").val() == "") { jQuery("#mainPageFio").addClass("error"); isValid = false; }
		else { jQuery("#mainPageFio").removeClass("error") }

		if (jQuery("#mainPagePhone").val() == "") { jQuery("#mainPagePhone").addClass("error"); isValid = false; }
		else { jQuery("#mainPagePhone").removeClass("error") }

		if (!isValid) return

		window.showEditorModal()

		var maxKey = Math.max(...Object.keys(window.images)); // находим максимальный ключ
		if (maxKey) {
			var image = window.images[maxKey]; // получаем значение элемента по найденному ключу

			if (image) {
				$selectType.val(image["paper_type"])
				if (image["cadr"] == 2) {
					$selectFields.val(0)
				}
				else {
					$selectType.val(image["paper_type"])
				}
				$selectLaminat.val(image["laminat"])
			}
			else {
				$selectType.val(0)
				$selectFields.val(0)
				$selectLaminat.val(0)
			}

			checkUploadField()
		}

		init_select()

		return false;
	});

	jQuery('input.calcTablePrices').change(function () {
		calcTablePrice();
	});
	jQuery('select.calcTablePrices').change(function () {
		calcTablePrice();
	});
	jQuery('.tablePricesCountMinus').click(function () {
		var count = jQuery(this).next().val();
		if (count > 0) {
			jQuery(this).next().val(count - 1);
		}
		calcTablePrice();
		return false;
	}
	);
	jQuery('.tablePricesCountPlus').click(function () {
		var count = jQuery(this).prev().val();
		if (count < 999) {
			jQuery(this).prev().val(parseInt(count) + 1);
		}
		calcTablePrice();
		return false;
	});

	// loadingFader('show');
	jQuery('#modalFieldsButton').click(function () {
		let cadr = 0;
		if ($selectFields.val() == 0) {
			cadr = 1;
			jQuery(this).removeClass('btn-primary').addClass('btn-light').text("Кадрирование выключено");
		} else {
			jQuery(this).removeClass('btn-light').addClass('btn-primary').text("Кадрирование включено");
		}
		$selectFields.val(cadr);
		let ids = getSelected();
		jQuery.each(ids, function (key, val) {
			window.saveData(val, 'cadr', cadr);
			window.saveData(val, 'position_h', 0);
			window.saveData(val, 'position_v', 0);
		});

		// Вернуть выделение
		jQuery.each(ids, function (key, val) {
			jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
		});
		window.save_position_list()
		setInterval(() => {
			window.load_position_list()
		}, 1200);
		window.reset_element(true);
	});

	$selectFields.change(function () {
		checkUploadField();
		let cadr = 0;
		if (jQuery(this).val() == 1) {
			cadr = 1;
			jQuery('#modalFieldsButton').removeClass('btn-danger').addClass('btn-light');
		} else {
			jQuery('#modalFieldsButton').removeClass('btn-light').addClass('btn-danger');
		}

		let ids = getSelected();
		jQuery.each(ids, function (key, val) {
			window.saveData(val, 'cadr', cadr);
			window.saveData(val, 'position_h', 0);
			window.saveData(val, 'position_v', 0);
		});

		// Вернуть выделение
		jQuery.each(ids, function (key, val) {
			jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
		});
		window.save_position_list()
		setInterval(() => {
			window.load_position_list()
		}, 1200);
		window.reset_element(true);

	});




	$selectCount.on("change", function () {
		let count = jQuery(this).val()
		if (count <= 0) {
			count = 1
		}

		if (count > 999) {
			count = 999
		}

		jQuery(this).val(count)

		let ids = getSelected();
		jQuery.each(ids, function (key, val) {
			window.saveData(val, 'count', count);
		});

		// Вернуть выделение
		jQuery.each(ids, function (key, val) {
			jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
		});
		window.save_position_list()
		setInterval(() => {
			window.load_position_list()
		}, 1200);
		window.reset_element(true);
	});

	$selectCount.parent().find(".btn").on("click", function () {
		$selectCount.trigger("change")
	})

	var first_modalSize = true

	$selectSize.change(function () {
		if (first_modalSize) {
			window.openBootstrapModal(jQuery('#please_check_all_fields'))
		}

		if (!validation_save_data_retention($selectSize.val(), $selectType.val(), $selectLaminat.val())) {
			alert("Вы не можете использовать этот тип ламинации для этого размера")
			return false;
		}


		first_modalSize = false
		checkUploadField();
		let size = parseInt($selectSize.val());


		// Сбросить прокручивание если переключается на другую вкладку
		if (window.select_tab != size) {
			position_list_css_padding_top = 0
			position_list_css_padding_bottom = 0
			position_list_scrollTop = 1
			window.load_position_list()
		}

		if (size !== NaN) {
			let ids = getSelected();

			if (ids.length > 0) {
				jQuery.each(ids, function (key, val) {
					window.saveData(val, 'paper_size', size);
					window.saveData(val, 'position_h', 0);
					window.saveData(val, 'position_v', 0);
				});

				// Вернуть выделение
				jQuery.each(ids, function (key, val) {
					jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
				});
				position_list_css_padding_top = 0
				position_list_css_padding_bottom = 0
				position_list_scrollTop = 0
				window.load_position_list()

				window.select_tab = size
				genTabs()
				renderTabs()
				window.reset_element(true)
				window.selectedImages = []
				reset_text_count_selected()
			}
			else {
				window.save_position_list()
				window.select_tab = size
				genTabs()
				renderTabs()
				window.reset_element(true)
				window.selectedImages = []
				reset_text_count_selected()
			}

		}
		else {
			checkUploadField();
		}
	});

	$selectType.change(function () {
		checkUploadField();
		let type = jQuery(this).val();
		if (type != '') {
			let ids = getSelected();
			jQuery.each(ids, function (key, val) {
				window.saveData(val, 'paper_type', type);
			});

			// Вернуть выделение
			jQuery.each(ids, function (key, val) {
				jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
			});
		}
		window.save_position_list()
		setInterval(() => {
			window.load_position_list()
		}, 600);
		window.reset_element(true);
	});

	$selectLaminat.change(function () {
		checkUploadField();
		let lam = jQuery(this).val();
		if (lam != '') {
			let ids = getSelected();
			jQuery.each(ids, function (key, val) {
				window.saveData(val, 'laminat', lam);
			});

			// Вернуть выделение
			jQuery.each(ids, function (key, val) {
				jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
			});
		}
		window.save_position_list()
		setInterval(() => {
			window.load_position_list()
		}, 1200);
		window.reset_element(true);
	});

	$uploadFile.on("click", function () {
		if (!$selectSize.val() || !$selectType.val() || !$selectFields.val() || !$selectLaminat.val()) {
			window.openBootstrapModal(jQuery('#please_check_all_fields_2'))
			return false;
		}
	});

	jQuery('.deleteImages').click(function () {
		let ids = getSelected();


		if (ids.length > 0) {
			// eslint-disable-next-line no-restricted-globals
			if (confirm('Действительно удалить выбранные изображения?')) {
				jQuery.each(ids, function (key, val) {
					delete (window.images[val]);
				});

				calcEditorPrice();

				let data = {};
				data.ids = ids;
				loadingFader('show');
				jQuery.ajax({
					url: '/ajax/editor/delete',
					type: 'POST',
					data: data,
					success: function (response, status, jqXHR) {
						loadingFader('hide');
						window.preloadImages();
						window.selectedImages = []
						reset_text_count_selected()
						genTabs()
						renderTabs()
						window.reset_element(true)
					},
					// функция ошибки ответа сервера
					error: function (jqXHR, status, errorThrown) {
						loadingFader('hide');
						window.preloadImages();
						reset_text_count_selected()
						genTabs()
						renderTabs()
						window.reset_element(true)
						// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
					}
				});
			}
		}
		else {
			// eslint-disable-next-line no-restricted-globals
			if (confirm('Удалить ВСЕ изображения из всех форматов?')) {
				// eslint-disable-next-line no-restricted-globals
				if (confirm('Вы уверены что хотите удалить ВСЕ изображения из всех форматов?')) {
					ids = []
					jQuery.each(window.images, function (key, val) {
						ids.push(key)
					});

					calcEditorPrice();

					let data = {};
					data.ids = ids;
					loadingFader('show');
					jQuery.ajax({
						url: '/ajax/editor/delete',
						type: 'POST',
						data: data,
						success: function (response, status, jqXHR) {
							loadingFader('hide');
							window.images = {}
							window.selectedImages = []
							window.preloadImages();
							reset_text_count_selected()
							genTabs()
							renderTabs()
							window.reset_element(true)
						},
						// функция ошибки ответа сервера
						error: function (jqXHR, status, errorThrown) {
							loadingFader('hide');
							window.preloadImages();
							window.images = {}
							genTabs()
							renderTabs()
							reset_text_count_selected()
							window.reset_element(true)
							// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
						}
					});
				}
			}
		}
		return false;
	});

	jQuery('.copyImages').click(function () {
		window.showCopyMenuModal()
		jQuery('#CopyModalSize').val("")
		jQuery('#CopyFramingWithUs').val("")
	});

	jQuery("#CopyMenuModal").on("click", "#button_modal_copy", function () {

		jQuery('#CopyModalSize').removeClass("border_error")
		jQuery('#CopyModalType').removeClass("border_error")
		jQuery('#CopyModalFields').removeClass("border_error")
		jQuery('#CopyModalLaminat').removeClass("border_error")
		jQuery('#CopyFramingWithUs').removeClass("border_error")

		let valid = true
		if (jQuery('#CopyModalSize').val() == "") { valid = false; jQuery('#CopyModalSize').addClass("border_error") }
		if (jQuery('#CopyModalType').val() == "") { valid = false; jQuery('#CopyModalType').addClass("border_error") }
		if (jQuery('#CopyModalFields').val() == "") { valid = false; jQuery('#CopyModalFields').addClass("border_error") }
		if (jQuery('#CopyModalLaminat').val() == "") { valid = false; jQuery('#CopyModalLaminat').addClass("border_error") }
		if (jQuery('#CopyFramingWithUs').val() == "") { valid = false; jQuery('#CopyFramingWithUs').addClass("border_error") }

		if (!validation_save_data_retention(jQuery('#CopyModalSize').val(), jQuery('#CopyModalType').val(), jQuery('#CopyModalLaminat').val())) {
			valid = false;
			alert("Вы не можете использовать этот тип ламинации для этого размера")
		}

		if (!valid) {
			window.showCopyMenuModal()
			return true;
		}

		window.hideCopyMenuModal()
		let size = jQuery('#CopyModalSize').val();
		let type = jQuery('#CopyModalType').val();
		let fields = jQuery('#CopyModalFields').val();
		let laminat = jQuery('#CopyModalLaminat').val();
		let count = jQuery('#defaultCount').val();

		if (jQuery('#CopyFramingWithUs').val() == "0") {
			fields = "2";
		}

		let ids = getSelected();


		let data = {
			"size": size,
			"type": type,
			"fields": fields,
			"laminat": laminat,
			"count": count,
			"ids": ids,
		}

		loadingFader('show', true);
		jQuery.ajax({
			url: '/ajax/editor/copy',
			type: 'POST',
			data: data,
			dataType: 'json',
			success: function (response, status, jqXHR) {
				jQuery.each(response, function (key, val) {
					window.images[key] = val;
				});

				loadingFader('hide', true);

				jQuery(".imagesSizeContainerInner").map(function () {
					let add_img_card = jQuery(this).find(".add_img_card")
					if (add_img_card.length == 0) {
						add_img_card = jQuery(`<div class="add_img_card"><svg xmlns="http://www.w3.org/2000/svg" width="232" height="232" viewBox="0 0 232 232" fill="none">
							<path d="M199.375 116C199.375 116.961 198.993 117.883 198.313 118.563C197.633 119.243 196.711 119.625 195.75 119.625H119.625V195.75C119.625 196.711 119.243 197.633 118.563 198.313C117.883 198.993 116.961 199.375 116 199.375C115.039 199.375 114.117 198.993 113.437 198.313C112.757 197.633 112.375 196.711 112.375 195.75V119.625H36.25C35.2886 119.625 34.3666 119.243 33.6867 118.563C33.0069 117.883 32.625 116.961 32.625 116C32.625 115.039 33.0069 114.117 33.6867 113.437C34.3666 112.757 35.2886 112.375 36.25 112.375H112.375V36.25C112.375 35.2886 112.757 34.3666 113.437 33.6867C114.117 33.0069 115.039 32.625 116 32.625C116.961 32.625 117.883 33.0069 118.563 33.6867C119.243 34.3666 119.625 35.2886 119.625 36.25V112.375H195.75C196.711 112.375 197.633 112.757 198.313 113.437C198.993 114.117 199.375 115.039 199.375 116Z" fill="#7E7E7E"/>
							</svg></div>`)
					}
					jQuery(this).append(add_img_card)
				})

				window.preloadImages();
				window.selectedImages = []
				reset_text_count_selected()
				window.save_position_list()
				window.reset_element(true)
			},
			// функция ошибки ответа сервера
			error: function (jqXHR, status, errorThrown) {
				// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
			}
		});

		window.preloadImages();
		window.selectedImages = []
		reset_text_count_selected()
		window.save_position_list()
		window.reset_element(true)

		return false;
	});

	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new Tooltip(tooltipTriggerEl)
	});

});

jQuery("#check_promocode").click(function () {
	jQuery.ajax({
		url: '/ajax/editor/check_promocode',
		type: 'POST',
		cache: false,
		data: {
			"promocodes": jQuery("#form_check_promocode_input_promocode").val()
		},
		success: function (response, status, jqXHR) {
			let data = JSON.parse(response);
			let discount = data["discount"]
			let type = data["type"]
			jQuery("#div_promocode").removeClass("d-none")
			let text = discount
			if (type == "percent") {
				text += "%"
			}
			if (type == "sum") {
				text += " ₽"
			}

			jQuery("#form_check_promocode .return_text").html(text)
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
})

jQuery("#check_the_order").click(function () {
	jQuery.ajax({
		url: '/ajax/editor/check_the_order',
		type: 'POST',
		cache: false,
		data: {
			"order_id": jQuery("#form_check_the_order_input_order_id").val()
		},
		success: function (response, status, jqXHR) {
			let dataArray = JSON.parse(response);
			jQuery("#div_check_the_order").removeClass("d-none");
			jQuery("#div_check_the_order").html("")
			let orderFound = false;
			for (let i = 0; i < dataArray.length; i++) {
				let status = dataArray[i].status;
				let id = dataArray[i].id;
				let date = dataArray[i].date;
				switch (status) {
					case "new": status = "в обработке";
						break;
					case "active": status = "активный";
						break;
					case "completed": status = "выполнен";
						break;
					case "paidfor": status = "оплачен";
						break;
					case "sent": status = "отправлен";
						break;
					case "cancelled": status = "отменен";
						break;
					case "returned": status = "возврат средств";
						break;
					default: status = "неизвестный статус";
				}

				let text = `Номер: ${id}, Статус: ${status}, Дата: ${new Date(date).toLocaleString('ru-RU')}`;

				if (status === "активный") {
					orderFound = true;
					let newHtml = `<div style="text-align: center;">${text}.<br>Ваша очередь: ${dataArray[i].order}</div>`;
					jQuery("#div_check_the_order").append(newHtml);
				}
				if (!orderFound) {
					let newHtml = `<div style="text-align: center;">${text}</div>`;
					jQuery("#div_check_the_order").append(newHtml);
				}
			}
		},
		error: function (jqXHR, status, errorThrown) {
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
})

jQuery("#check_number_balls").click(function () {
	jQuery.ajax({
		url: '/ajax/editor/check_number_balls',
		type: 'POST',
		cache: false,
		data: {
			"fio": jQuery("#form_check_number_balls_input_fio").val(),
			"phone": jQuery("#form_check_number_balls_input_phone").val()
		},
		success: function (response, status, jqXHR) {
			jQuery("#div_count_bonus").removeClass("d-none")
			jQuery("#form_check_number_balls .count_bonus").html(`Количество баллов: ${jqXHR.responseText
				}`)
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
})

var hide_controlCrop = false
$selectProcessingMethod.change(function () {
	let processing_method_type = jQuery(this).val()
	let ids = getSelected();

	checkUploadField()

	if (processing_method_type == "0") {
		jQuery.each(ids, function (key, val) {
			window.saveData(val, 'cadr', 2);
			window.saveData(val, 'position_h', 0);
			window.saveData(val, 'position_v', 0);
		});

		// Вернуть выделение
		jQuery.each(ids, function (key, val) {
			jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
		});
	}

	if (processing_method_type == "1") {
		jQuery.each(ids, function (key, val) {
			window.saveData(val, 'cadr', 0);
			window.saveData(val, 'position_h', 0);
			window.saveData(val, 'position_v', 0);
		});

		// Вернуть выделение
		jQuery.each(ids, function (key, val) {
			jQuery(`.imageSelect[value=${val}]`).prop('checked', true);
		});
	}
	window.save_position_list()
	window.reset_element(true)
});

jQuery('input[name="deliveryType"]').change(function () {
	window.calcOrder(0)
});

jQuery('body').on("change", "select.orderCalc", function () {
	window.calcOrder(0)
});


var useBalls = 0;
window.calcOrder = function (send = 0) {
	var data = {};
	data.fio = jQuery('#orderClientName').val();
	data.phone = jQuery('#orderClientPhone').val();
	data.messenger = jQuery('#orderClientMessenger').val();
	data.postIndex = jQuery('#orderClientIndex').val();
	data.address = jQuery('#orderClientAddress').val();
	data.recipient_name = jQuery('#orderRecipientName').val();
	data.recipient_phone = jQuery('#orderRecipientPhone').val();

	data.send = send;

	data.delivery = jQuery('input[name="deliveryType"]:checked').val();
	if (data.delivery == undefined) {
		data.delivery = "Почтой России";
	}

	data.balls = jQuery('#ballsUseField input').val();
	data.useBalls = useBalls;
	data.city = jQuery('#orderCity').val();

	data.processing_method = $selectProcessingMethod.is(':checked')


	// // console.log('data', data);

	if (jQuery('#orderCity').val() == "0") {
		jQuery('#orderCity').addClass("error");
	}
	else {
		jQuery('#orderCity').removeClass("error")
	}

	if (send == 1) {
		var isValid = true;

		[
			"#orderClientName", "#orderClientPhone",
			"#orderClientIndex", "#orderClientAddress",
			"#orderRecipientName", "#orderRecipientPhone"
		].forEach(function (field) {
			if (jQuery(field).val() == "") {
				jQuery(field).addClass("error");
				isValid = false;
			} else {
				jQuery(field).removeClass("error");
			}
		});

		if (jQuery('#orderCity').val() == "0") {
			jQuery('#shipping_method :input').addClass("error");
			isValid = false;
		}
		else {
			jQuery('#shipping_method :input').removeClass("error")
		}


		if (!isValid) {
			return
		}
	}


	jQuery.ajax({
		url: '/ajax/editor/calcOrder',
		type: 'POST',
		cache: false,
		data: data,
		dataType: 'json',
		success: function (response, status, jqXHR) {
			// // console.log('response', response);
			if (send == 0) {
				jQuery('#orderContent').empty();
				jQuery.each(response.orderTable, function (key, size) {
					jQuery.each(size.types, function (key1, type) {
						if (type.lam.count > 0) {
							type.lam.balls = fixBalls(type.lam.balls);
							jQuery('#orderContent').append(`
															<tr class="price_content align-content-center tablePrices">
																	<td class="table_field">${size.title}</td>
																	<td class="table_field">${type.title}</td>
																	<td class="table_field">${type.lam.count}</td>
																	<td class="table_field">Есть</td>
																	<td class="table_field">${type.lam.price}</td>
																	<td class="table_field">${type.lam.balls}</td>
															</tr>`);
						}
						if (type.nolam.count > 0) {
							type.nolam.balls = fixBalls(type.nolam.balls);
							jQuery('#orderContent').append(`
															<tr class="price_content align-content-center tablePrices">
																	<td class="table_field">${size.title}</td>
																	<td class="table_field">${type.title}</td>
																	<td class="table_field">${type.nolam.count}</td>
																	<td class="table_field">Нет</td>
																	<td class="table_field">${type.nolam.price}</td>
																	<td class="table_field">${type.nolam.balls}</td>
															</tr>`);
						}
					});
				});
				// jQuery('#orderClientName').val(response.fio);
				// jQuery('#orderClientPhone').val(response.phone);
				// jQuery('#orderClientMessenger').val(response.messenger);

				jQuery('#ballsCount').html(fixBalls(response.userBalls));
				jQuery('#baseBallsCount').html(fixBalls(response.baseBalls));
				if (response.canUseBalls == 0) {
					jQuery('.canUsedBallsCount').removeClass("d-none");
					jQuery('#ballsUseField').addClass("d-none");
					jQuery('#orderPayBalls').addClass("pe-none");
					jQuery('#orderPayBalls').addClass("not_active_bonus");
				}
				else {
					jQuery('.canUsedBallsCount').addClass("d-none");
					jQuery('#ballsUseField').removeClass("d-none");
					jQuery('#orderPayBalls').removeClass("pe-none");
					jQuery('#orderPayBalls').removeClass("not_active_bonus");
				}
				if (response.usedBalls > 0) {
					jQuery('#ballsUseField input').val(fixBalls(response.usedBalls));
				}
				else jQuery('#ballsUseField input').val(fixBalls(response.canUseBalls));

				useBalls = response.useBalls;
				if (response.useBalls == 1) setPayBalls();
				else setTakeBalls();

				//jQuery('#ballsUseField').val(fixBalls(response.usedBalls));
				jQuery('#orderCity').val();
				if (response.promo != '') {
					jQuery('#promoCodeBlock').html(response.promo);
					jQuery('#promocodeForm').hide();
					jQuery('#promocodeUsed').show();
					jQuery('#totalPromoBlock').show();
					if (response.promo_type == "sum") {
						jQuery('#totalPromoField').html('-' + response.discount);
					}
					if (response.promo_type == "percent") {
						jQuery('#totalPromoField').html('-' + ((response.basePrice / 100) * response.discount));
					}
				} else {
					jQuery('#promocodeForm').show();
					jQuery('#promocodeUsed').hide();
					jQuery('#totalPromoBlock').hide();
				}

				jQuery('#baseCostField').html(fixBalls(response.basePrice));
				jQuery('#baseCostFieldBalls').html(fixBalls(response.baseBalls));

				jQuery('#totalFinalField').html(fixBalls(response.finalPrice));
				jQuery('#totalFinalFieldBalls').html(fixBalls(response.finalBalls));

				if (response.usedBalls > 0) {
					jQuery('#totalBallsBlock').show();
					jQuery('#totalBallsField').html('-' + response.usedBalls);
					jQuery('#totalBallsFieldBalls').html('-' + response.baseBalls);
				} else {
					jQuery('#totalBallsBlock').hide();
					jQuery('#totalBallsField').html('');
					jQuery('#totalBallsFieldBalls').html('');
				}

				// Обработка доставки.
				if (response.selfDelivery) {
					jQuery('.delivery_self_element').show();
					jQuery('.not_delivery_self_element').hide();
				} else {
					jQuery('.delivery_self_element').hide();
					jQuery('.not_delivery_self_element').show();
				}

				if (response.delivery_cost > 0) {
					jQuery("#totalDeliveryField").html(response.delivery_cost)
					jQuery("#totalDeliveryBlock").show();
				}
				else {
					jQuery("#totalDeliveryField").html(0)
					jQuery("#totalDeliveryBlock").hide();
				}


				// Цена обработки
				if (response.cadr2Price <= 0) {
					jQuery("#totalСadr2PriceBlock").hide()
				}
				else {
					jQuery("#totalСadr2PriceBlock").show()
					jQuery('#totalСadr2PriceField').html(fixBalls(response.cadr2Price));
				}



				if (response.freeDelivery) {
					jQuery(".delivery_free_text").removeClass("d-none")
				}
				else {
					jQuery(".delivery_free_text").addClass("d-none")
				}

				jQuery('input[name="deliveryType"]').prop("checked")
				jQuery(`input[name="deliveryType"][value="${response.delivery}"]`).prop("checked", true)


				jQuery('#cost_of_free_shipping').html(response.valueDelivery);

			} else {
				window.images = {};
				jQuery('#order_id').html(response.order_id);
				window.hideEditorModal()
				window.closeBootstrapModal(jQuery('#prewviewModal'))
				window.closeBootstrapModal(jQuery('#orderModal'))
				window.openBootstrapModal(jQuery('#orderedModal'))
			}
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
}

jQuery("#back").click(function () {
	window.showEditorModal()
	window.closeBootstrapModal(jQuery('#prewviewModal'))
	window.closeBootstrapModal(jQuery('#orderModal'))
})

function usePromo(code) {
	var data = {};
	data.code = code;
	jQuery.ajax({
		url: '/ajax/editor/setPromo',
		type: 'POST',
		cache: false,
		data: data,
		success: function (response, status, jqXHR) {
			window.calcOrder();
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			// // console.log('ОШИБКА AJAX запроса: ' + status, jqXHR.responseText);
		}
	});
}

function fixBalls(balls) {
	return Math.round(balls * 100) / 100;
}

function setPayBalls() {
	jQuery('#orderPayBalls').removeClass('border-dark').addClass('border-danger');
	jQuery('#orderTakeBalls').removeClass('border-danger').addClass('border-dark');
}

function setTakeBalls() {
	jQuery('#orderTakeBalls').removeClass('border-dark').addClass('border-danger');
	jQuery('#orderPayBalls').removeClass('border-danger').addClass('border-dark');
}

jQuery('document').ready(function () {
	jQuery('#orderButton').click(function () {

		if (Object.keys(window.images).length <= 0) {
			return
		}

		jQuery('#orderClientName').val(jQuery('#mainPageFio').val());
		jQuery('#orderClientPhone').val(jQuery('#mainPagePhone').val());
		jQuery('#orderClientMessenger').val(jQuery('#mainPageMessenger').val());


		window.calcOrder();
		window.hideEditorModal()
		window.openBootstrapModal(jQuery('#orderModal'))
		return false;
	});

	jQuery('#orderPayBalls').click(function () {
		useBalls = 1;
		//        jQuery('#orderPayBalls').removeClass('border-dark text-dark bg-light').addClass('border-danger text-light bg-danger');
		//        jQuery('#orderTakeBalls').removeClass('border-danger text-light bg-danger').addClass('border-dark text-dark bg-light');
		//        setPayBalls();
		window.calcOrder();
	});

	jQuery('#orderTakeBalls').click(function () {
		useBalls = 0;
		//        jQuery('#orderTakeBalls').removeClass('border-dark text-dark bg-light').addClass('border-danger text-light bg-danger');
		//        jQuery('#orderPayBalls').removeClass('border-danger text-light bg-danger').addClass('border-dark text-dark bg-light');
		//        setTakeBalls();
		window.calcOrder();
	});

	jQuery('#promoButton').click(function () {
		usePromo(jQuery('#promoField').val());
		return false;
	});
	jQuery('#deletePromo').click(function () {
		// eslint-disable-next-line no-restricted-globals
		if (confirm('Действительно отменить промокод?')) usePromo('');
		return false;
	});

	jQuery('#sendOrder').click(function () {
		window.calcOrder(1);
		return false;
	});
});

jQuery("#root").on("click", ".countsControl button", function () {
	let type = jQuery(this).html()
	let input = jQuery(this).parents(".countsControl").find("input")
	let key = jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', '')
	let val = parseInt(input.val())
	if (type == "+") {
		val += 1
		if (val < 1000) {
			input.val(val)
			window.saveData(key, 'count', val);
		}
	}
	else if (type == "-") {
		val -= 1
		if (val > 0) {
			input.val(val)
			window.saveData(key, 'count', val);
		}
	}
	calcEditorPrice()
});

jQuery("#root").on("change", ".countsControl input", function () {
	let input = jQuery(this)
	let key = jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', '')
	let val = parseInt(input.val())
	if (val > 999) {
		val = 999
		input.val(val)
	}
	else if (val <= 0) {
		val = 1
		input.val(val)
	}
	window.saveData(key, 'count', val);
	calcEditorPrice()
});


jQuery('#orderCity').on('blur', function () {
	window.calcOrder(0);
});


jQuery(".drag_and_drop_the_image_to_crop_text").click(function () {
	jQuery(this).parents(".modal-footer").toggleClass("margin_bottom")
})


function reset_imageCanvas_position() {

	jQuery(`.imageWrapper[data-cadr="0"]:not(.ui-draggable-dragging) .imageCanvas img`).map(function () {
		let key = jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', '')
		if (window.images[key]["position_v"] == 0)
			jQuery(this).css("top", 0)

		if (window.images[key]["position_h"] == 0)
			jQuery(this).css("left", 0)
	})

	jQuery(`.imageWrapper[data-cadr="1"] .imageCanvas img`).map(function () {
		let key = jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', '')
		if (window.images[key]["position_v"] != 0) {
			window.saveData(key, "position_v", 0)
			window.images[key]["position_v"] = 0
		}

		if (window.images[key]["position_h"] != 0) {
			window.saveData(key, "position_h", 0)
			window.images[key]["position_h"] = 0
		}
	})
}
